import React from 'react';
import { Box, Chip, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { CardPlanImage } from '@icons';
import { Color } from '@types';

interface CardPlanHeaderProps {
	name: string;
	opacity?: string;
	planNote?: string;
}

export const CardPlanHeader: React.FC<CardPlanHeaderProps> = ({ name, opacity = '1', children, planNote }) => {
	return (
		// 	<Box>
		// 		{/* <Box styles={{ position: 'absolute' }}>
		// 			<CardPlanImage opacity={opacity} />
		// 		</Box> */}
		// 		<Box
		// 			styles={{
		// 				position: 'absolute',
		// 				width: '386px',
		// 				height: '72px',
		// 				backgroundColor: Color.Izibizi,
		// 				opacity: opacity,
		// 				borderRadius: '16px 16px 0px 0px',
		// 			}}
		// 		></Box>
		// 		<Box
		// 			styles={{
		// 				position: 'absolute',
		// 				padding: '24px 32px',
		// 				display: 'flex',
		// 				justifyContent: 'space-between',
		// 				flexDirection: 'row',
		// 			}}
		// 		>
		// 			<Typography appearance="body-100-08" colorsLevel="backDarkPrimary">
		// 				{name}
		// 			</Typography>
		// 			{name.toLowerCase() === 'starter' && (
		// 				<Box
		// 					styles={{
		// 						height: '24px',
		// 						borderRadius: '100px',
		// 						gap: '4px',
		// 						padding: '0px 12px',
		// 						backgroundColor: '#FFFFFF',
		// 						alignItems: 'center',
		// 						border: '1px solid rgb(195, 202, 212)',
		// 					}}
		// 				>
		// 					<Typography appearance="microcopy-75-03">{planNote}</Typography>
		// 				</Box>
		// 			)}
		// 		</Box>
		// 		{children}
		// 	</Box>
		// );
		<Box>
			<Box
				styles={{
					position: 'absolute',
					width: '386px',
					height: '72px',
					backgroundColor: name.toLowerCase() === 'standard' ? Color.IzibiziOpacity : Color.Izibizi,
					// opacity: opacity,
					borderRadius: '16px 16px 0px 0px',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: '24px 32px',
				}}
			>
				<Typography appearance="body-100-08" colorsLevel="backDarkPrimary">
					{name}
				</Typography>
				{name.toLowerCase() === 'standard' && (
					<Box
						styles={{
							height: '24px',
							borderRadius: '100px',
							gap: '4px',
							padding: '0px 12px',
							backgroundColor: '#FFFFFF',
							alignItems: 'center',
							border: '1px solid rgb(195, 202, 212)',
							zIndex: 2,
							position: 'relative',
						}}
					>
						<Typography appearance="microcopy-75-03">{planNote}</Typography>
					</Box>
				)}
			</Box>
			{children}
		</Box>
	);
};
